import styled from 'styled-components';

export const FullFooter = styled.div`
  max-width: 100%;
  background: linear-gradient(
    132deg,
    rgb(18, 145, 219) 0%,
    rgb(108, 196, 186) 100%
  );
  @media screen and (max-width: 1200px) {
    padding: 0 25px;
  }
  & p {
    text-align: center;
    font-size: 1.5rem;
    margin: 0;
    font-weight: 700;
    color: #efefef;
  }
`;

export const FooterInnerCon = styled.div`
  display: flex;
  max-width: 1200px;
  margin: auto;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 50px 25px;
  flex-wrap: wrap;
  @media screen and (max-width: 650px) {
    flex-direction: column;
    row-gap: 50px;
  }
`;

export const FooterLogoCon = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 15px;
  & p {
    margin: 0;
    font-size: 2rem;
    color: ${({ theme }) => theme.mainColors.hvid};
    font-weight: 800;
  }
`;

export const FooterElement = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  & h2 {
    color: ${({ theme }) => theme.mainColors.hvid};
  }
  & a {
    display: block;
    position: relative;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.mainColors.hvid};
    text-decoration: none;
    & svg {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  &:nth-child(2) a {
    padding-left: 30px;
  }
`;
